/**
 * Created by rickborst on 24/07/2017.
 */

/**
 * Converts response from read action to application data.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Settings data.
 */
function convertFromRead (response = {}) {

    return {
        personal: response.personal || null,
        payment: response.payment || null,
        devices: response.devices || null
    };
}

/**
 * Converts data for request.
 *
 * @param {string} connectCode - Connect code.
 * @returns {Object} Converted request data.
 */
function convertForConnectDevice (connectCode) {

    return {
        deviceName: 'TV',
        pin: connectCode || null
    };
}

/**
 * Converts response from read action to application data.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Settings data.
 */
function convertFromConnectDevice (response = {}) {

    return response;
}

export {
    convertFromRead,
    convertForConnectDevice,
    convertFromConnectDevice
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/settings.js